import React from 'react';
import NameRow from '../name_row';
import { getSideBarWidth, topOffset } from '../../helpers/size_helpers';
import { scrollBarSize } from 'components/common/size_helpers';

export default class TimelineSidebar extends React.Component {
  constructor(props) {
    super(props);

    this.state = { ...this.scaleHeights() };
  }

  scaleHeights() {
    if (this.props.timelineConfig.viewOnly) {
      return { scaleBarHeight: 0, scaleHeight: 45 };
    } else {
      return { scaleBarHeight: 25, scaleHeight: 70 };
    }
  }

  columns() {
    return this.props.resourceTree.tree.map(resource => {
      return (
        <NameRow
          key={`NameRow-${resource.unique_key}`}
          scale={this.props.scale}
          resource={resource}
          compactView={this.props.timelineConfig.compactView}
          thickBars={this.props.timelineConfig.thickBars}
          fontSize={this.props.timelineConfig.fontSize}
          headerWidths={this.props.headerWidths}
          updateHeaderWidths={this.props.updateHeaderWidths}
          persistHeaderWidths={this.props.persistHeaderWidths}
        />
      );
    });
  }

  rowHeadingHeight() {
    return this.state.scaleHeight + topOffset();
  }

  rowHeight() {
    if (this.props.height) {
      if (this.props.heightOfRows > this.props.height) {
        return this.props.heightOfRows + scrollBarSize();
      } else {
        return this.props.heightOfRows;
      }
    }
  }

  render() {
    let sideBarWidth;
    if (window.featureFlags.a_16745_custom_timeline_resizeable) {
      sideBarWidth = this.props.headerWidths.reduce((a, b) => a + b, 0);
    } else {
      sideBarWidth = getSideBarWidth(
        this.props.resourceTree,
        this.props.timelineConfig.fontSize
      );
    }

    const milestones = this.props.timelineConfig.milestones;

    const rowHeadingsStyle = {
      width: this.props.width - this.props.getHeaderColumnsWidth,
      left: 0,
      top:
        milestones &&
        milestones.length > 0 &&
        this.props.showMilestoneBars &&
        !this.props.timelineConfig.viewOnly
          ? `calc(var(--custom-timeline-milestone-swimlane-height) + ${this.props.extraHeight}px)`
          : 0,
    };

    return (
      <div className='timeline-pivot-row-headings' style={rowHeadingsStyle}>
        <div style={{ width: sideBarWidth }}>{this.columns()}</div>
      </div>
    );
  }
}
